module.exports = __webpack_public_path__ + "img/AGR-i-2-II.0f112349.png";